export default __webpack_public_path__ + "static/media/T680_Home.9d2f5dde.png";